<div>
    <div *ngIf="!selected" class="arm-summary">0 Items selected</div>
    <div *ngIf="selected" class="arm-summary">
        <div fxLayout="row" class="arm-summary-item">
            <span class="arm-summary-name" fxFlex="45">Name:</span>
            <span class="arm-summary-value" [title]="selected.name" fxFlex>{{selected.name}}</span>
        </div>
        <div fxLayout="row" class="arm-summary-item">
            <span class="arm-summary-name" fxFlex="45">Description:</span>
            <span class="arm-summary-value" [title]="selected.description" fxFlex>{{selected.description}}</span>
        </div>
        <div fxLayout="row" class="arm-summary-item">
            <span class="arm-summary-name" fxFlex="45">Dialable:</span>
            <span class="arm-summary-value" [title]="selected.dialable" fxFlex>
              <span [innerHTML]="selected.dialable | trueFalsePipe"></span>
            </span>
        </div>
        <div fxLayout="row" class="arm-summary-item">
            <span class="arm-summary-name" fxFlex="45">Displayed in users table:</span>
            <span class="arm-summary-value" [title]="selected.primary" fxFlex>
                 <span [innerHTML]="selected.primary | trueFalsePipe"></span>
            </span>
        </div>
        <div fxLayout="row" class="arm-summary-item">
            <span class="arm-summary-name" fxFlex="45">Combined:</span>
            <span class="arm-summary-value" [title]="selected.isCombined" fxFlex>
                <span [innerHTML]="selected.isCombined | trueFalsePipe"></span>
            </span>
        </div>
        <div class="combined-properties" *ngIf="selected.isCombined">
            <div fxLayout="row" class="arm-summary-item">
                <span class="arm-summary-name" fxFlex="60">Use values after normalization:</span>
                <span class="arm-summary-value" [title]="selected.normalizeCombinedProperty" fxFlex>
                 <span [innerHTML]="selected.normalizeCombinedProperty | trueFalsePipe"></span>
            </span>
            </div>
            <div fxLayout="row" class="arm-summary-item">
                <span class="arm-summary-name" fxFlex="60">Combined property 1:</span>
                <span class="arm-summary-value" [title]="selected.combinationProperty1" fxFlex>{{selected.combinationProperty1}}</span>
            </div>
            <div fxLayout="row" class="arm-summary-item">
                <span class="arm-summary-name" fxFlex="60">Combined property 2:</span>
                <span class="arm-summary-value" [title]="selected.combinationProperty2" fxFlex>{{selected.combinationProperty2}}</span>
            </div>
            <div fxLayout="row" class="arm-summary-item">
                <span class="arm-summary-name" fxFlex="60">Delimiter:</span>
                <span class="arm-summary-value" [title]="selected.combinationDelimiter" fxFlex>{{selected.combinationDelimiter}}</span>
            </div>
        </div>
    </div>
</div>
